import { render, staticRenderFns } from "./UserSearchSelect.vue?vue&type=template&id=3a04b8d0&scoped=true"
import script from "./UserSearchSelect.vue?vue&type=script&lang=js"
export * from "./UserSearchSelect.vue?vue&type=script&lang=js"
import style0 from "./UserSearchSelect.vue?vue&type=style&index=0&id=3a04b8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04b8d0",
  null
  
)

export default component.exports